export const RESEND_COOLDOWN_MS = 30000;

const resendCooldownEndsAtByKey = new Map<string, number>();

export const getRemainingCooldownSeconds = (
  cooldownEndsAt: number | null,
  now = Date.now()
) => {
  if (!cooldownEndsAt) return 0;

  return Math.max(0, Math.ceil((cooldownEndsAt - now) / 1000));
};

export const setStoredResendCooldownEndsAt = (
  cooldownKey: string,
  cooldownEndsAt: number
) => {
  resendCooldownEndsAtByKey.set(cooldownKey, cooldownEndsAt);
};

export const getStoredResendCooldownEndsAt = (cooldownKey: string) => {
  return resendCooldownEndsAtByKey.get(cooldownKey) ?? null;
};

export const clearStoredResendCooldown = (cooldownKey: string) => {
  resendCooldownEndsAtByKey.delete(cooldownKey);
};
